/**
 * Jeden pohybový systém webu (proposal 003 §7 bod 3).
 * Jediná easing křivka a pevné doby trvání, aby animace působily jako jeden rukopis.
 * Vše se respektuje spolu s `useReducedMotion`.
 */

/** Jediná easing křivka webu. */
export const EASE = [0.22, 0.61, 0.36, 1] as const;

/** Doby trvání ve vteřinách (pro framer-motion). */
export const DUR = {
  fast: 0.15,
  base: 0.25,
  slow: 0.35,
} as const;

/* Hover slideshow náhledů karty (proposal 003 §6.2). */
/** Ochrana proti prolétnutí myší. */
export const INTENT_MS = 120;
/** Prodleva mezi snímky slideshow. */
export const DWELL_MS = 1200;
/** Crossfade snímku (vteřiny). */
export const FADE_S = DUR.slow;
/** Maximum snímků v hover slideshow. */
export const MAX_FRAMES = 4;
